import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import strings, { lang as defaultLang } from "../helpers/Localization";
import { ToastContainer } from "react-toastify";
import userManager from "../helpers/UserManager";
import appSettings from "../AppSettings";

//CUSTOM ELEMENTS
import Shell from "../aGlobalDesign/Shell/Shell";

//MUI ELEMENTS
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";

import AlertDialog from "./Dialog/AlertDialog";
import Modal from "../aGlobalDesign/Modal/Modal";
import Inputs from "../aGlobalDesign/Inputs/Inputs";
import IconComponent from "../aGlobalDesign/Icons/IconComponent";
import Loader from "../aGlobalDesign/Loader/Loader";
import Status from "../aGlobalDesign/Status/Status";

import SelectResourceDialog from "../components/Dialog/SelectResourceDialog";
import getReleaseNotesFR from "../containers/ReleaseNote/releaseNoteFR";
import Avatar from "../aGlobalDesign/Avatar/Avatar";

const styles = {
    root: {
        flexGrow: 1
    }
};

class PermanentDrawer extends React.Component {
    constructor() {
        super();
        this.state = {
            portalClientSelectionDialog: null,
            selectResourceDialog: null,
            filesList: [],

            parameters: null,
            newOrga: null,

            openReleaseNote: false,
            currentReleaseFR: getReleaseNotesFR()[0],

            openModalLinkPortal: false,
            codePairingPortal: null,
            selectIntercomPairing: null
        };
    }

    componentDidMount() {
        this.setState({ selectIntercomPairing: this.props.communication?.linkedPortalAgent?.id ? "lastPairedIntercom" : "otherIntercom" });
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.communication?.linkedPortalAgent?.id;
        const currentId = this.props.communication?.linkedPortalAgent?.id;

        if (prevId !== currentId) {
            this.setState({ selectIntercomPairing: this.props.communication?.linkedPortalAgent?.id ? "lastPairedIntercom" : "otherIntercom" });
        }
    }

    onSelectLanguage(language) {
        if (localStorage.getItem("lang") !== language) {
            localStorage.setItem("lang", language);
            window.location.reload();
        }
        this.props.changeLanguage(language);
    }

    OpenParameters() {
        const currentOrganisationUser = this.props.currentuser.user.organizationUsers.find(ou => ou.organizationId === this.props.currentuser.currentorganization.id);
        const parameters = {
            organizationUser: {
                organizationId: this.props.currentuser.currentorganization.id,
                organization: null,
                userId: this.props.currentuser.user.id,
                user: null,
                callCenterId: currentOrganisationUser.callCenterId,
                callCenter: null,
                portalAgentId: currentOrganisationUser.portalAgentId,
                portalAgent: null,
                isDisabled: currentOrganisationUser.isDisabled,
                isOrganizationAdministrator: currentOrganisationUser.isOrganizationAdministrator,
                displayName: currentOrganisationUser.displayName,
                avatar: currentOrganisationUser.avatar
            }
        };
        this.setState({ parameters: parameters });
    }

    OnChangeParameter() {
        const organizationUser = this.state.parameters.organizationUser;
        if (organizationUser.displayName === null || organizationUser.displayName === "") {
            this.props.OpenDialog({
                description: strings.emailNeeded,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }
        if (this.state.newOrga) {
            this.props.history.push("/");
            this.props.changeAppBarTitle("");
            this.props.ChangeCurrentMenuName("");
            this.props.GetOrganization(this.state.newOrga);
        }
        this.props.EditOrganizationUser(organizationUser, () => {
            window.location.reload();
        }, this.state.filesList.length > 0 ? this.state.filesList : null);
    }

    linkIntercomToPilot(forcePairing) {
        const idPortal = this.state.codePairingPortal ? Number(this.state.codePairingPortal) : this.props.communication?.linkedPortalAgent?.id;
        const forceLink = forcePairing ? true : false;
        this.props.communication.webRTConnection.invoke("linkPortalToPilot", idPortal, forceLink).then((result) => {
            console.log("==>linkPortalToPilot -- idPortal:", idPortal );
            if (result.success === false) {
                const code = result.code;
                console.error("==> linkPortalToPilot Code Error:", code);
                this.props.OpenDialog({
                    title: code === "INTERCOM_ALREADY_PAIRED" ? strings.IntercomAlreadyPaired : strings.PairingImpossible,
                    boldText: code === "INTERCOM_ALREADY_PAIRED" ? strings.boldTextIntercomAlreadyPaired
                        : code === "INTERCOM_NOT_FOUND" ? strings.boldTextIntercomNotFound
                            : code === "INTERCOM_UNAUTHORIZED" ? strings.boldTextIntercomUnauthorized
                                : code === "INTERCOM_DISCONNECTED" ? strings.boldTextIntercomDisconnected
                                    : strings.Warning,
                    description: code === "INTERCOM_ALREADY_PAIRED" ? strings.TextIntercomAlreadyPaired
                        : code === "INTERCOM_DISCONNECTED" ? strings.TextIntercomDisconnected
                            : code === "INTERCOM_UNAUTHORIZED" ? strings.TextIntercomUnauthorized
                                : code === "INTERCOM_NOT_FOUND" ? strings.TextIntercomNotFound
                                    : null,
                    secondaryLabel: code === "INTERCOM_ALREADY_PAIRED" ? strings.cancel : null,
                    primaryLabel: code === "INTERCOM_ALREADY_PAIRED" ? strings.ToContinue : strings.Restart,
                    onPrimaryAction: () => {
                        if (code === "INTERCOM_ALREADY_PAIRED") {
                            this.linkIntercomToPilot(true);
                        }
                    },
                    onSecondaryAction: () => {
                        if (code === "INTERCOM_DISCONNECTED" || code === "INTERCOM_UNAUTHORIZED" || code === "INTERCOM_NOT_FOUND") {
                            this.setState({ openModalLinkPortal: false });
                        }
                    },
                    clickOutsideToClose: true
                });
                return;
            }
            this.setState({
                openModalLinkPortal: false,
                codePairingPortal: null
            });
        });
    }

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const { classes } = this.props;
        const currentPortalAgent = this.props.communication && this.props.communication.linkedPortalAgent;
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        const isMenuOpenTools = this.props.home.currentMenuName === "dashboard"
        || this.props.home.currentMenuName === "callLink"
        || this.props.home.currentMenuName === "ContentLibrary"
        || this.props.home.currentMenuName === "callLog";
        const isMenuOpenGestion = this.props.home.OrganisationMenuOpen && this.props.toggleOrganisationMenu
        || this.props.home.MonitoringMenuOpen && this.props.toggleMonitoringMenu
        || this.props.home.AdministrationMenuOpen && this.props.toggleAdministrationMenu
        || this.props.home.SystemAdministratorMenuOpen && this.props.toggleSysAdminMenu;
        const orgId = this.props.currentuser && this.props.currentuser.currentorganization ? this.props.currentuser.currentorganization.id : null;
        const orgUser = orgId ? this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId) : null;
        const cucallCenterId = orgId ? this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId : null;
        const waitingListLength = orgId && this.props.monitoring.callapps ? this.props.monitoring.callapps.filter(ca => ca && ca.callCenter && ca.callCenter.id === cucallCenterId && ca.status === 45).length : 0;
        const videoMessagesNotBeenSeen = this.props.administration.videomessagesNotBeenSeencount;
        const isAllowAdvertisements = this.props.currentuser && this.props.currentuser.currentorganization && this.props.currentuser.currentorganization.organizationParameters.some(op => op.key === "Public-AllowAdvertisements" && op.value === "True") || false;

        return (
            <div className={classes.root}>
                <ToastContainer />
                <div className={classes.appFrame}>
                    <AlertDialog />
                    <Shell
                        ShellHeaderLogo={{ name: "ska_link_logo", ext: ".svg" }}
                        ShellNavMenuEntries={
                            {
                                currentMenuName: this.props.home.currentMenuName,
                                categoryBoxes: [
                                    {
                                        title: strings.tools,
                                        hasPermission: accessrights && accessrights.hasPermission(10, "consult") + accessrights.hasPermission(20, "consult") + accessrights.hasPermission(40, "consult") > 30,
                                        isOpen: isMenuOpenTools,
                                        containers: [
                                            {
                                                name: "dashboard",
                                                hasPermission: accessrights && accessrights.hasPermission(10, "consult") > 10,
                                                isOpen: ["dashboardFullView", "dashboardAgents", "dashboardClients"].includes(this.props.home.currentMenuName),
                                                onSelect: (e) => {
                                                    console.log("select dashboard", e?.type, e?.target, e?.currentTarget);
                                                    e?.preventDefault?.();
                                                    e?.stopPropagation?.();
                                                    this.props.history.push("/dashboard");
                                                },
                                                children: null
                                            },
                                            {
                                                name: "callLink",
                                                hasPermission: accessrights && accessrights.hasPermission(20, "consult") > 10,
                                                isOpen: ["callLink"].includes(this.props.home.currentMenuName),
                                                onSelect: () => this.props.history.push("/callLink"),
                                                children: null,
                                                specialItem: <Status statusId={this.props.communication.linkedPortalAgent && this.props.communication.linkedPortalAgent.modeSleep === 2 && this.props.communication.linkedPortalAgent.lockedByPilot === orgUser.id ? 30
                                                    : !this.props.communication.callSession ? null :
                                                        this.props.communication.callSession.status === "starting" ? 50 : 60}/>
                                            },
                                            {
                                                name: "WaitingList",
                                                hasPermission: accessrights && accessrights.hasPermission(420, "consult") > 10,
                                                isOpen: ["WaitingList"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/WaitingList?" + (param ? param : "")),
                                                children: null,
                                                specialItem: waitingListLength ? <div style={{ position: "absolute", right: "14px",
                                                    color: "white", backgroundColor: "#FF002E", fontSize: "12px", borderRadius: "50px", textAlign: "center", height: "15px", minWidth: "16px", paddingTop: "1px"
                                                }}>{waitingListLength}</div> : null
                                            },
                                            {
                                                name: "Messaging",
                                                hasPermission: accessrights && accessrights.orgLimitations.allowVideoMessages && accessrights.hasPermission(600, "consult") > 10,
                                                isOpen: ["Messaging"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Messages?" + (param ? param : "")),
                                                children: null,
                                                specialItem: videoMessagesNotBeenSeen ? <div style={{ position: "absolute", right: "14px",
                                                    color: "white", backgroundColor: "#FF002E", fontSize: "12px", borderRadius: "50px", textAlign: "center", height: "15px", minWidth: "16px", paddingTop: "1px"
                                                }}>{videoMessagesNotBeenSeen}</div> : null
                                            },
                                            {
                                                name: "callLog",
                                                hasPermission: accessrights && accessrights.hasPermission(15, "consult") > 10,
                                                isOpen: ["callLog"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/callLog?" + (param ? param : "")),
                                                children: null
                                            },
                                            {
                                                name: "ContentLibrary",
                                                hasPermission: accessrights && accessrights.hasPermission(40, "consult") > 10,
                                                isOpen: ["ContentLibrary"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Resources/ContentsList?" + (param ? param : "")),
                                                children: null
                                            },
                                            {
                                                name: "URLCalls",
                                                hasPermission: accessrights && ( accessrights.hasPermission(400, "consult") > 10 || accessrights.hasPermission(430, "consult") > 10),
                                                isOpen: ["Permanent", "ClientsRecall"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/URLCalls?" + (param ? param : ""))
                                            },
                                            {
                                                name: "Advertisement",
                                                hasPermission: isAllowAdvertisements && accessrights && accessrights.hasPermission(700, "consult") > 10,
                                                isOpen: ["Carousel", "Commitment"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => {
                                                    if (!this.props.home.CarouselMenuOpen) {
                                                        this.props.toggleCarouselMenu();
                                                    }
                                                    this.props.history.push("/advertisement/Carousel?" + (param ? param : ""));
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        title: strings.gestion,
                                        hasPermission: accessrights && accessrights.hasPermission(50, "consult") + accessrights.hasPermission(60, "consult") + accessrights.hasPermission(70, "consult") + accessrights.hasPermission(80, "consult") + accessrights.hasPermission(90, "consult") + accessrights.hasPermission(100, "consult") + accessrights.hasPermission(200, "consult") + accessrights.hasPermission(300, "consult") + accessrights.hasPermission(200, "create") > 90,
                                        isOpen: isMenuOpenGestion,
                                        containers: [
                                            {
                                                name: "organisation",
                                                hasPermission: accessrights && accessrights.hasPermission(50, "consult") + accessrights.hasPermission(60, "consult") + accessrights.hasPermission(70, "consult") + accessrights.hasPermission(300, "consult") > 40,
                                                isOpen: ["Zones", "CallCenters", "DecisionTrees", "CallCategories"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Organisation?" + (param ? param : ""))
                                            },
                                            {
                                                name: "portals",
                                                hasPermission: accessrights && accessrights.hasPermission(80, "consult") + accessrights.hasPermission(90, "consult") > 20,
                                                isOpen: ["PortalsAgent", "PortalsClient", "CallApp"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Monitoring?" + (param ? param : ""))
                                            },
                                            {
                                                name: "usersAndRoles",
                                                hasPermission: accessrights && accessrights.hasPermission(100, "consult") + accessrights.hasPermission(200, "consult") + accessrights.hasPermission(200, "create") > 30,
                                                isOpen: ["UsersList", "UserGroupsList", "InvitationsList"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Gestion/Users?" + (param ? param : ""))
                                            },
                                            {
                                                name: "superAdmin",
                                                hasPermission: isSystemAdministrator,
                                                isOpen: ["organizations"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/SuperAdmin/OrganizationsList?" + (param ? param : ""))

                                            }
                                        ]
                                    },
                                    {
                                        title: strings.Storage,
                                        hasPermission: accessrights && accessrights.hasPermission(500, "consult") > 10,
                                        isOpen: true,
                                        containers: [
                                            {
                                                name: "Storage",
                                                hasPermission: accessrights && accessrights.hasPermission(500, "consult") > 10,
                                                isOpen: ["Storage"].includes(this.props.home.currentMenuName),
                                                onSelect: (param) => this.props.history.push("/Storage?" + (param ? param : "")),
                                                children: null }
                                        ]
                                    }
                                ]
                            }
                        }
                        userAvatar={orgUser && orgUser.avatar ? JSON.parse(orgUser.avatar).PhotoThumbnailURL : null}
                        onOpenUserModal={() => {
                            this.OpenParameters();
                        }}
                        onOpenLinkPortalModal={() => {
                            this.setState({ openModalLinkPortal: true });
                        }}
                        colorStatusPairing={currentPortalAgent?.isLinked ? "var(--green-base)" : "var(--red-base)"}
                        iconStatusPairing={currentPortalAgent?.isLinked ? "devicePaired" : "deviceNotPaired"}
                    >
                        {this.props.children}
                    </Shell>
                </div>
                <Modal open={this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.connectionStatus}
                    hideClose
                    validationTitle={strings.Retry}
                    onValidate={() => {
                        window.location.href = "/";
                    }}
                    title={strings.SessionAlreadyInProgress + "."}
                >
                    <span className="TextContent16" style={{ color: "var(--grey-base)" }}>
                        {strings.TextSessionAlreadyInProgress}
                    </span>
                </Modal>
                <Modal open={this.state.parameters !== null}
                    onClose={() => this.setState({ parameters: null, newOrga: null })}
                    onValidate={ () => this.OnChangeParameter()}
                    title={strings.Parameters}
                    icon={"settings"}
                    headerButton={[
                        {
                            type: "primary-icon-red",
                            onClick:
                                () => {
                                    localStorage.clear();
                                    userManager.signoutRedirect();
                                },
                            nameIcon: "logout"
                        }
                    ]}
                    fields={
                        this.state.parameters ? [
                            {
                                type: "textfield",
                                title: strings.myName,
                                placeholder: strings.name,
                                value: this.state.parameters.organizationUser.displayName,
                                onChange: (e) => {
                                    const su = { ...this.state.parameters };
                                    su.organizationUser.displayName = e.target.value;
                                    this.setState({ parameters: su });
                                }
                            },
                            {
                                type: "importfile",
                                title: strings.Avatar,
                                access: "image",
                                value: this.state.parameters.organizationUser.avatar ? JSON.parse(this.state.parameters.organizationUser.avatar).PhotoName : "",
                                thumbnail: this.state.parameters.organizationUser.avatar ? JSON.parse(this.state.parameters.organizationUser.avatar).PhotoThumbnailURL : "",
                                onAddFiles: (inputFiles) => {
                                    if (inputFiles[0].size > this.props.configuration.multipartBodyLengthLimit) {
                                        this.props.OpenDialog({
                                            title: strings.fileTooBig,
                                            description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                                            primaryLabel: "OK",
                                            clickOutsideToClose: true
                                        });
                                        return;
                                    }
                                    const su = { ...this.state.parameters };
                                    const filesList = this.state.filesList;
                                    if (!filesList.some(e => e.name === inputFiles[0].name)) {
                                        filesList.push(inputFiles[0]);
                                    }
                                    su.organizationUser.avatar = JSON.stringify({
                                        PhotoName: inputFiles[0].name,
                                        PhotoURL: inputFiles[0].name,
                                        PhotoThumbnailURL: null
                                    });

                                    this.setState({
                                        filesList: filesList,
                                        parameters: su
                                    });
                                },
                                onOpenModal: () => {
                                    this.setState({ selectResourceDialog: "avatar" });
                                }
                            },
                            {
                                type: "selectElement",
                                openTop: false,
                                adjustHeight: true,
                                title: strings.Organization,
                                elementsList: { results: this.props.currentuser.user.organizationUsers.map((el) => {return el.organization;}) },
                                selectedElementId: this.state.newOrga ? this.state.newOrga.id : this.props.currentuser.currentorganization.id,
                                onSelectElement: (element) => {
                                    this.setState({ newOrga: element });
                                }
                            },
                            {
                                type: "custom",
                                child: <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ width: "110px" }}>{"Sécurité"}</p>
                                    <p style={{ fontSize: "15px", textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                        const url = appSettings.AuthenticationAuthority + "/Account/ForgotPassword?encodedemail=" + btoa(this.props.currentuser.user.email);
                                        window.location.href = url;
                                    }}>Changer le mot de passe</p>
                                </div>
                            },
                            {
                                type: "custom",
                                child: <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ width: "110px" }}>{strings.SortApplicationVersion}</p>
                                    <p style={{ fontSize: "15px", textDecoration: "underline", cursor: "pointer" }} onClick={() => this.setState({ openReleaseNote: true })}>SkaLink 3.0.1</p>
                                </div>
                            }
                        ] : null}
                />
                <Modal open={this.state.openModalLinkPortal}
                    onClose={() => this.setState({ openModalLinkPortal: false })}
                    onValidate={ () => this.linkIntercomToPilot()}
                    validationTitle={strings.ConfirmPairing}
                    disableValidate={Number(this.state.codePairingPortal) < 2 && this.state.selectIntercomPairing === "otherIntercom"}
                    title={strings.PairingIntercom}
                    icon={"deviceAdd"}
                    fields={[
                        {
                            type: "selectElement",
                            preventEmpty: true,
                            adjustHeight: true,
                            elementsList: { results: currentPortalAgent ? [
                                { id: "lastPairedIntercom", name: `${currentPortalAgent?.name} (${strings.lastPairing})` },
                                { id: "otherIntercom", name: strings.OtherIntercom }
                            ]
                                :
                                [
                                    { id: "otherIntercom", name: strings.OtherIntercom }
                                ]
                            },
                            value: this.state.selectIntercomPairing,
                            selectedElementId: this.state.selectIntercomPairing,
                            onSelectElement: (element) => {
                                this.setState({ selectIntercomPairing: element.id });
                            }
                        },

                        ...this.state.selectIntercomPairing === "otherIntercom"
                            ? [
                                {
                                    type: "custom",
                                    child: <p style={{ fontSize: "14px", fontWeight: 700, color: "var(--carbone)", margin: 0 }}>
                                        {strings.EnterPairingCodeDisplayedOnIntercom}
                                    </p>
                                },
                                {
                                    type: "textfield",
                                    value: this.state.codePairingPortal,
                                    maxlength: 4,
                                    onChange: (e) => {
                                        this.setState({ codePairingPortal: e.target.value });
                                    }
                                }
                            ]
                            : []
                    ]}
                />

                { this.state.selectResourceDialog ?
                    <SelectResourceDialog open={this.state.selectResourceDialog !== null}
                        icon="qrcode"
                        title={strings.selectContent}
                        onClose={() => this.setState({ selectResourceDialog: null })}
                        onSelect={ (element) => {
                            const su = { ...this.state.parameters };
                            if (element.contentTypeId === 20) {
                                const eldata = JSON.parse(element.data);
                                su.organizationUser[this.state.selectResourceDialog] = JSON.stringify({
                                    PhotoName: element.name,
                                    PhotoURL: eldata.Uri,
                                    PhotoThumbnailURL: eldata.ThumbnailUri
                                });
                            }
                            this.setState({
                                parameters: su,
                                selectResourceDialog: null
                            });
                        }}/> : null
                }
                <Modal open={this.state.openReleaseNote}
                    onClose={() => {
                        this.setState({ openReleaseNote: false });
                    }}
                    icon={"note"}
                    title={strings.releaseNote}
                    headerInfo={`${strings.versionReleaseNote} ${this.state.currentReleaseFR.version}`}
                >
                    <div className="container-release-note">
                        {
                            this.state.currentReleaseFR.titleFeatures ?
                                <h2 className="title-release-note">{this.state.currentReleaseFR.titleFeatures}</h2>
                                :
                                null
                        }
                        {
                            this.state.currentReleaseFR.features && this.state.currentReleaseFR.features.map((feature, index) => {
                                return (
                                    <div className="container-feature" key={index}>
                                        <h3 className="title-feature">{feature.title ? feature.title : null}</h3>
                                        <div className="text-feature" dangerouslySetInnerHTML={{ __html: feature.notes }} />
                                    </div>
                                );
                            })
                        }
                        {
                            this.state.currentReleaseFR.titleBugs ?
                                <h2 className="title-release-note">{this.state.currentReleaseFR.titleBugs}</h2>
                                :
                                null
                        }
                        {
                            this.state.currentReleaseFR.bugs && this.state.currentReleaseFR.bugs.map((bug, index) => {
                                return (
                                    <div className="container-feature" key={index}>
                                        <h3 className="title-feature">{bug.title ? bug.title : null}</h3>
                                        <div className="text-feature" dangerouslySetInnerHTML={{ __html: bug.notes }} />
                                    </div>
                                );
                            })
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

PermanentDrawer.propTypes = {
    classes: PropTypes.object.isRequired
};

// export default withStyles(styles)(PermanentDrawer);
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(withStyles(styles)(PermanentDrawer)));

